import { COMMON_LABELS } from "../default-constants";
import {
  CONTRACT_SERVICE,
  EXAMINATION_STATUS,
  IOrderTargetItems,
  LABELS,
} from "./constants";

/**
 * 引数の契約サービスコードを基に画面表示用のラベルを返却する.
 * @param {string} contractService 契約サービスコード
 * @returns {string} 契約サービスラベル
 */
export const getDisplayContractService = (contractService: string) => {
  const { dPaymentBarcode, dPaymentInternet } = CONTRACT_SERVICE;
  switch (Number(contractService)) {
    case dPaymentBarcode.code:
      return dPaymentBarcode.label;
    case dPaymentInternet.code:
      return dPaymentInternet.label;
    default:
      return COMMON_LABELS.BLANK;
  }
};

/**
 * 引数の契約ルートがあれば画面表示用に整形して返却する.
 * @param {string | undefined} contractRoute 契約ルート
 * @returns {string} 契約ルートラベル
 */
export const getDisplayContractRoute = (contractRoute: string | undefined) => {
  if (contractRoute) {
    return contractRoute;
  } else {
    return LABELS.CONTRACT_DIRECTLY;
  }
};

/**
 * 引数の審査状況コードを基に画面表示用のラベルを返却する.
 * @param {number} examinationOrderTargetStatus 審査状況コード
 * @returns {string} 審査状況ラベル
 */
export const getDisplayExaminationOrderTargetStatus = (
  examinationOrderTargetStatus: number
) => {
  const {
    examinationAwaiting,
    reviewResultsAwaiting,
    examinationNg,
    examinationOk,
  } = EXAMINATION_STATUS;
  if (examinationOrderTargetStatus === examinationAwaiting.code) {
    return examinationAwaiting.label;
  } else if (examinationOrderTargetStatus === reviewResultsAwaiting.code) {
    return reviewResultsAwaiting.label;
  } else if (examinationOrderTargetStatus === examinationNg.code) {
    return examinationNg.label;
  } else if (examinationOrderTargetStatus === examinationOk.code) {
    return examinationOk.label;
  } else {
    return COMMON_LABELS.BLANK;
  }
};

/**
 * 仕向け先一覧を日付を昇順に並び替えて返却する.
 * @param {IOrderTargetItems[]} items 仕向け先一覧
 * @returns {IOrderTargetItems[]} 日付を昇順に並び替えられた仕向け先一覧
 */
export const getOrderTargetsSortedByDate = (items: IOrderTargetItems[]) => {
  return items
    .filter((item) => item.requestDate)
    .sort((a, b) => {
      if (a.requestDate !== b.requestDate) {
        return a.requestDate > b.requestDate ? 1 : -1;
      } else {
        return a.displayOrder - b.displayOrder;
      }
    });
};

/**
 * 仕向け先一覧を審査結果判定用に絞り込んで返却する.
 * @param {IOrderTargetItems[]} items 仕向け先一覧
 * @returns {IOrderTargetItems[]} 審査結果判定用に絞り込まれた仕向け先一覧
 */
export const getOrderTargetsFilteredByExaminationStatus = (
  items: IOrderTargetItems[]
) => {
  const { examinationNg, examinationOk } = EXAMINATION_STATUS;
  // 日付を昇順にソート後, V_Mで審査状況が審査NGまたは審査OKのみの仕向け先を絞り込む.
  return getOrderTargetsSortedByDate(items).filter(
    (item) =>
      item.orderTarget.includes(LABELS.V_M) &&
      (item.examinationOrderTargetStatus === examinationNg.code ||
        item.examinationOrderTargetStatus === examinationOk.code)
  );
};

/**
 * 審査結果判定が行われたか判定を行う.
 * @param {IOrderTargetItems[]} items 仕向け先一覧
 * @returns {boolean} true: 審査結果判定後, false: 審査結果判定前
 */
export const isAfterJudgement = (items: IOrderTargetItems[]) => {
  return items.some((item) => item.isApplied);
};

/**
 * 引数のV/Mブランドが仕向け先一覧に含まれているか判定を行う.
 * @param {string} vmBrand V/Mブランドのラベル
 * @param {IOrderTargetItems[]} items 仕向け先一覧
 * @returns {boolean} true: 含む, false: 含まれていない
 */
export const isDuplication = (vmBrand: string, items: IOrderTargetItems[]) => {
  return items.some((item) => item.orderTarget.includes(vmBrand));
};
